export function classSessionLabel(classTime) {
  if (!classTime) return '';
  const hourText = String(classTime).slice(0, 2);
  if (!/^\d{2}$/.test(hourText)) return '';
  const hour = Number(hourText);
  if (!Number.isInteger(hour) || hour < 0 || hour > 23) return '';
  return hour < 12 ? 'AM Session' : 'PM Session';
}
